export default {
  common: {
    save: "Сохранить изменения",
    cancel: "Отмена",
    saving: "Сохранение...",
    updating: "Обновление...",
    back: "Назад",
    error: "Ошибка",
    success: "Успех",
    toast: {
      success: "Успех",
      error: "Ошибка",
      info: "Информация",
      warning: "Предупреждение",
      copied: "Скопировано в буфер обмена",
      saved: "Изменения сохранены",
      deleted: "Удалено успешно",
      updated: "Обновлено успешно"
    },
    cabinClass: "Класс каюты",
    bookingReference: "Номер бронирования",
    confirmationNumbers: "Номера подтверждения",
    in: "в"
  },
  auth: {
    signOut: "Выйти",
    signOutSuccess: "Выход выполнен успешно",
    redirectingHome: "Перенаправление на главную страницу...",
    loginWithEmail: "Войти с помощью электронной почты",
    createAccount: "Создать аккаунт",
    forgotPassword: "Забыли пароль",
    forgotPasswordInstructions: "Войдите, используя свою электронную почту, а затем измените свой пароль",
    firstName: "Имя",
    lastName: "Фамилия",
    emailAddress: "Адрес электронной почты",
    confirmEmailAddress: "Подтвердите адрес электронной почты",
    termsAgreementPart1: "Создавая аккаунт, вы соглашаетесь с нашими",
    termsOfService: "Условиями обслуживания",
    privacyPolicy: "Политикой конфиденциальности",
    signUpToManageTrips: "Зарегистрируйтесь, чтобы начать управлять своими поездками",
    enterEmailForCode: "Введите свой адрес электронной почты, чтобы получить одноразовый код",
    passwordValidation: "Пароль должен содержать как минимум одну заглавную букву, одну строчную букву, одну цифру, один специальный символ и быть длиной от 8 до 15 символов.",
    verifyEmail: "Подтвердить электронную почту",
    noAccount: "Нет аккаунта? Зарегистрироваться",
    adtdTripPWaiting: "Ваше путешествие готово к импорту",
    adtdTripPWaitingDescription: "Пожалуйста, войдите в свою учетную запись или создайте новую, чтобы продолжить. Мы проверим, соответствует ли бронирование вашей личности.",
    loginDescription: "Отслеживайте рейсы, организуйте свои поездки и получайте доступ ко всей информации о путешествии. Всё, что нужно для беспроблемного путешествия, в одном месте.",
    loginAppDescription: "Вся информация о путешествии в одном месте"
  },
  settings: {
    title: "Настройки",
    profile: {
      title: "Мой профиль",
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Адрес электронной почты",
      country: "Страна",
      city: "Город",
      selectCountry: "Выберите или введите страну",
      enterCity: "Введите свой город"
    },
    language: {
      title: "Язык",
      preferred: "Предпочитаемый язык"
    },
    currency: {
      title: "Валюта",
      preferred: "Предпочитаемая валюта"
    },
    notifications: {
      title: "Уведомления",
      emailNotifications: "Уведомления по электронной почте",
      description: "Получайте уведомления по электронной почте о важных обновлениях"
    },
    consent: {
      title: "Управление согласием",
      open: "Открыть менеджер согласия",
      description: "Управляйте своими настройками конфиденциальности и файлов cookie"
    },
    about: {
      title: "О нас",
      tos: "Условия обслуживания",
      privacy: "Политика конфиденциальности",
      faq: "Часто задаваемые вопросы"
    },
    contact: {
      title: "Связаться с нами",
      email: "feedback@checkmytrip.com"
    },
    social: {
      title: "Найдите нас в социальных сетях"
    },
    profileUpdated: "Профиль обновлен успешно",
    updateError: "Ошибка при обновлении профиля",
    passwordMismatch: "Пароли не совпадают",
    passwordTooShort: "Пароль должен содержать не менее 8 символов",
    passwordUpdated: "Пароль обновлен успешно",
    changePassword: "Изменить пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите пароль",
    updatePassword: "Обновить пароль",
    deleteAccount: "Удалить аккаунт",
    deleteAccountDescription: "Удалите свой аккаунт и все связанные с ним данные навсегда",
    confirmDelete: "Вы уверены?",
    deleteWarning: "Это действие нельзя отменить. Это навсегда удалит ваш аккаунт и удалит все ваши данные с наших серверов.",
    confirmDeleteButton: "Да, удалить мой аккаунт",
    accountDeleted: "Ваш аккаунт был удален успешно.",
    deleteError: "Не удалось удалить аккаунт",
    feedback: {
      title: "Обратная связь",
      description: "Мы ценим ваш отзыв. Помогите нам улучшить наш сервис, поделившись своими мыслями.",
      button: "Оставить отзыв"
    }
  },
  newTrip: {
    title: "Добавить новую поездку",
    bookingReference: "Код бронирования",
    bookingReferenceDesc: "Введите ваш 6-значный код бронирования и убедитесь, что имя и фамилия в вашем профиле совпадают с указанными в бронировании.",
    bookingRefPlaceholder: "Код (напр. ABC123)",
    bookingRefTooShort: "Код бронирования должен содержать не менее 6 символов",
    bookingRefTooLong: "Код бронирования может содержать максимум 10 символов",
    lastNamePlaceholder: "Фамилия",
    findBooking: "Найти бронирование",
    gmailSync: "Синхронизировать с Gmail",
    gmailSyncDesc: "Разрешите нам сканировать ваш почтовый ящик Gmail для поиска бронирований поездок",
    connectGmail: "Подключить аккаунт Gmail",
    emailForward: "Переслать письмо с бронированием",
    emailForwardDesc: "Перешлите подтверждение бронирования, чтобы добавить свою поездку",
    emailCopied: "Адрес электронной почты скопирован",
    emailCopiedDesc: "Адрес электронной почты скопирован в буфер обмена",
    copyEmail: "Скопировать адрес электронной почты",
    manual: "Ручной ввод",
    manualDesc: "Добавьте детали своей поездки вручную",
    startManual: "Начать ручной ввод",
    bookingSubmitted: "Бронирование отправлено",
    processingBooking: "Мы ищем ваше бронирование...",
    gmailConsent: "Подключение Gmail",
    gmailProcessing: "Подключение к вашему аккаунту Gmail...",
    manualEntry: "Ручной ввод данных о поездке",
    manualEntryDesc: "Создайте поездку, самостоятельно добавив детали о перелетах и отелях",
    profileMismatch: "Извините, информация вашего профиля не соответствует бронированию. Пожалуйста, перейдите в Профиль и убедитесь, что ваши имя и фамилия совпадают с теми, которые использовались при бронировании. Вы также можете попробовать импортировать вашу поездку с помощью следующих вариантов ниже, переслав электронное письмо с подтверждением бронирования или введя данные поездки вручную.",
    drawer: {
      addTripDetails: "Добавить детали поездки",
      tripInfo: "Информация о поездке",
      tripName: "Название поездки",
      tripType: "Тип поездки",
      selectTripType: "Выберите тип поездки",
      leisure: "Отдых",
      business: "Бизнес",
      family: "Семья",
      bleisure: "Бизнес и отдых",
      travelers: "Количество путешественников",
      addFlight: "Добавить перелет",
      flightNumber: "Номер рейса (например, SU1234)",
      departureDate: "Дата вылета",
      addedFlights: "Добавленные перелеты",
      from: "Откуда:",
      to: "Куда:",
      terminal: "Терминал:",
      departure: "Вылет:",
      arrival: "Прибытие:",
      addHotel: "Добавить отель",
      hotelName: "Название отеля",
      cityName: "Название города",
      selectCheckInOut: "Выберите даты заезда и выезда",
      checkIn: "Заезд",
      checkOut: "Выезд",
      addedHotels: "Добавленные отели",
      createTrip: "Создать поездку",
      adding: "Добавление...",
      selectFlight: "Выберите рейс",
      confirmFlight: "Подтвердить рейс",
      step1: "Информация",
      step2: "Рейсы",
      step3: "Отели",
      step4: "Проверка",
      next: "Далее",
      back: "Назад",
      review: "Просмотреть",
      flightsStepEmpty: "Добавьте хотя бы один рейс в свою поездку",
      flightsStepWithFlights: "Вы добавили {{count}} рейс(ов)",
      hotelsStepEmpty: "Добавьте отели в свою поездку (необязательно)",
      hotelsStepWithHotels: "Вы добавили {{count}} отель(ей)",
      reviewTrip: "Просмотрите свою поездку",
      reviewDescription: "Проверьте детали своей поездки перед ее созданием",
      tripSummary: "Обзор поездки",
      flightsSummary: "Рейсы",
      hotelsSummary: "Отели"
    }
  },
  discover: {
    title: "Откройте для себя впечатления",
    subtitle: "Находите и исследуйте занятия для вашего следующего приключения",
    getInspired: "Вдохновитесь",
    searchFilters: "Фильтры поиска",
    search: "Поиск",
    city: "Город",
    enterCityName: "Введите название города",
    priceRange: "Диапазон цен",
    min: "Мин",
    max: "Макс",
    radius: "Радиус (км)",
    enterRadius: "Введите радиус",
    searchButton: "Поиск",
    categoryTypes: "Категории",
    popularActivities: "Популярные занятия",
    searchPlaceholder: "Поиск занятий, мест или впечатлений...",
    allActivities: "Все занятия",
    inspiration: {
      location: "Местоположение",
      price: "Диапазон цен",
      bestTimeToVisit: "Лучшее время для посещения",
      howToGetThere: "Как добраться"
    },
    categories: {
      tour: "Тур",
      adventure: "Приключение",
      food: "Еда и напитки",
      culture: "Культура",
      sightseeing: "Осмотр достопримечательностей",
      entertainment: "Развлечения",
      nature: "Природа",
      wellness: "Оздоровление",
      sport: "Спорт",
      workshop: "Мастер-класс"
    }
  },
  index: {
    greeting: "Привет, Путешественник",
    greetingWithName: "Привет, {{name}}",
    manageTrips: "Управляйте своими поездками",
    bookingRef: "Номер бронирования",
    lastName: "Фамилия",
    addTrip: "Добавить поездку",
    timeline: "Ваша Хронология",
    travelPlans: "Ваши планы поездок",
    errorFetchingTrips: "Убедитесь, что вы подключены к учетной записи с соответствующим именем и электронной почтой.",
    viewUpcomingFlights: "Посмотреть предстоящие рейсы",
    welcome: {
      title: "Добро пожаловать в ваше путешествие!",
      features: {
        tripManagement: {
          title: "Управление поездками",
          description: "Храните все детали своей поездки в одном месте - перелеты, отели и мероприятия."
        },
        tripAlerts: {
          title: "Оповещения о поездках",
          description: "Получайте своевременные уведомления о ваших рейсах, изменениях выхода на посадку и важных обновлениях поездок."
        },
        offers: {
          title: "Персональные предложения",
          description: "Получайте индивидуальные предложения о путешествиях, основанные на ваших предпочтениях и прошлых поездках."
        },
        inspiration: {
          title: "Вдохновение для путешествий",
          description: "Откройте новые направления и получите персонализированные рекомендации для ваших приключений"
        }
      },
      tips: {
        profile: "Заполните свой профиль, чтобы получать персональные рекомендации",
        addTrip: "Нажмите кнопку +, чтобы добавить свою первую поездку",
        notifications: "Включите уведомления, чтобы никогда не пропускать важные обновления о поездках",
        dates: "Отслеживайте важные даты путешествия в календаре"
      },
      getStarted: "Быстрые советы для начала работы",
      ready: "Готовы начать свое путешествие? Давайте сделаем каждую поездку незабываемой! ✈️"
    },
    importAdtdTripSuccess: "Поездка успешно импортирована",
    importAdtdTripError: "Не удалось импортировать поездку в этот аккаунт",
    checkYourTrips: "Проверьте свои поездки в приложении"
  },
  tripCard: {
    daysLeft: "дней",
    flightDetails: "Детали рейса",
    terminal: "Терминал",
    gate: "Выход",
    checkIn: "Регистрация",
    flightInfo: "Информация о рейсе",
    airline: "Авиакомпания",
    flight: "Рейс",
    departure: "Отправление",
    arrival: "Прибытие",
    getFlightDetails: "Получить детали рейса",
    destinationInfo: "Информация о пункте назначения",
    weather: "Погода",
    activities: "Рекомендуемые занятия",
    food: "Рестораны и кафе",
    today: "Сегодня",
    dayAgo: "1 день назад",
    daysAgo: "{{count}} дней назад",
    remainingDay: "1 день остался",
    remainingDays: "{{count}} дней осталось",
    checkStatus: "Проверить статус",
    tripStatus: {
      ongoing: "Текущая поездка",
      upcoming: "Предстоящая поездка",
      past: "Прошедшая поездка"
    },
    booking: "Бронирование",
    taxiTransfer: "Трансфер на такси",
    taxiTransferDesc: "Заказать трансфер на такси до отеля или аэропорта",
    taxiTransferComingSoon: "Трансфер на такси скоро будет доступен",
    tripDetails: "Детали поездки",
    deleteTrip: "Удалить поездку",
    confirmDelete: "Удалить поездку?",
    deleteWarning: "Это действие нельзя отменить. Это навсегда удалит вашу поездку в {{tripName}} и удалит ее из вашей учетной записи.",
    confirmDeleteButton: "Да, удалить поездку",
    tripDeleted: "Поездка успешно удалена.",
    deleteError: "Не удалось удалить поездку",
    cabinClass: "Класс каюты",
    bookingReference: "Номер бронирования",
    confirmationNumbers: "Номера подтверждения",
    carRental: "Аренда автомобиля",
    carModel: "Модель автомобиля",
    pickupLocation: "Место получения",
    dropoffLocation: "Место возврата",
    pickup: "Получение",
    dropoff: "Возврат",
    confirmationNumber: "Номер подтверждения",
    addToCalendar: "Добавить в календарь",
    notifications: "Уведомления",
    notificationsDescription: "Важные уведомления о ваших поездках",
    noNotifications: "Пока нет уведомлений",
    notificationsOnMobile: "Эта функция доступна только в мобильном приложении на данный момент.",
    economy: "Эконом",
    loadingNotifications: "Загрузка уведомлений..."
  },
  weather: {
    in: "Погода в",
    loading: "Загрузка данных о погоде...",
    currentWeather: "Текущая погода",
    forecast: "Прогноз",
    temperature: "Температура",
    feelsLike: "Ощущается как",
    wind: "Ветер",
    humidity: "Влажность",
    precipitation: "Осадки",
    pressure: "Давление",
    visibility: "Видимость",
    uvIndex: "УФ-индекс",
    sunrise: "Восход",
    sunset: "Закат",
    daily: "Ежедневно",
    hourly: "Почасовой",
    today: "Сегодня",
    tomorrow: "Завтра",
    min: "Мин",
    max: "Макс"
  },
  sidebar: {
    myTrips: "Мои поездки",
    discover: "Обнаружить",
    newTrip: "Новая поездка",
    profile: "Профиль",
    feedback: "Обратная связь"
  },
  errors: {
    configurationError: "Ошибка конфигурации",
    websiteNotConfigured: "Веб-сайт настроен неправильно."
  }
}
